import { FC } from "react";
import { useSidebar } from "@/hooks";
import { Button, Icon, Icons } from "@ir/ui";

const SidebarCollapsableHandler: FC<{
  showHandler?: boolean;
}> = ({ showHandler = true }) => {
  const { isCollapsedSidebar, toggleCollapseSidebar } = useSidebar();

  const _classNames = "sidebar-toggle";
  return (
    showHandler && (
      <Button
        className={_classNames}
        noStyle
        onPress={toggleCollapseSidebar}
        aria-label="Toggle Sidebar"
        htmlTitle={isCollapsedSidebar ? "Expand Sidebar" : "Collapse Sidebar"}
      >
        <Icon name={isCollapsedSidebar ? Icons.ChevronRightDouble : Icons.ChevronLeftDouble} />
      </Button>
    )
  );
};

export default SidebarCollapsableHandler;
